<div id="paymentContent">
  @if (hobexFormAction) {
    <form [id]="formId" [class]="formId" [action]="hobexFormAction" data-brands="VISA MASTER"></form>
  }
  <div id="sslLabel" class="k-justify-content-center" style="display: none;">
    <kendo-label>{{ 'bookingHandler.onlinePayment.paymentForm.sslProtect' | translate }}&nbsp;
      <kendo-svg-icon [icon]="icons.lockIcon"></kendo-svg-icon>
    </kendo-label>
  </div>
</div>
<div id="paymentResultContent" style="display: none; height: 100%; width: 100%;">
  <iframe id="resultPaymentIframe" name="iframe_a" style="height: 100%; width: 100%; border: none;"></iframe>
</div>
<div #scriptContainer style="display: none;"></div>
